 import { useState } from "react";

function PenaltyApprovalModal({ request, onClose, onResolved }) {
  const [loading, setLoading] = useState(false);
  const [disputeReason, setDisputeReason] = useState("");
  const [showDisputeInput, setShowDisputeInput] = useState(false);

  /* --------------------------------------------------
     🛑 SAFETY CHECKS
     - request nahi → modal mat dikhao
     - already disputed / completed → modal mat dikhao
  -------------------------------------------------- */
  if (
    !request ||
    request.status === "disputed" ||
    request.status === "completed"
  ) {
    return null;
  }

  /* ==================================================
        🟢 ACTION 1: PAY PENALTY
  ================================================== */
  const handlePay = async () => {
    if (!window.confirm("Confirm payment of penalty?")) return;

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        "https://borrowhub-backend.onrender.com/api/return/approve-penalty",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ requestId: request._id }),
        }
      );

      const data = await res.json();
      if (data.success) {
        alert("✅ Penalty Paid! Item returned.");
        onResolved(); // 🔥 parent refresh + modal close
      } else {
        alert(data.message || "Payment failed");
      }
    } catch (err) {
      alert("Error processing payment");
    } finally {
      setLoading(false);
    }
  };

  /* ==================================================
        🔴 ACTION 2: DISPUTE (Send to Admin)
  ================================================== */
  const handleDispute = async () => {
    // First click → textarea dikhao
    if (!showDisputeInput) {
      setShowDisputeInput(true);
      return;
    }

    // Second click → submit dispute
    if (!disputeReason.trim()) {
      alert("Please write a reason for dispute.");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        "https://borrowhub-backend.onrender.com/api/return/dispute-penalty",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            requestId: request._id,
            reason: disputeReason,
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        alert("⚖️ Sent to Admin Court!");
        onResolved(); // 🔥 parent refresh + modal close
      } else {
        alert(data.message || "Dispute failed");
      }
    } catch (err) {
      alert("Error sending dispute");
    } finally {
      setLoading(false);
    }
  };

  /* ==================================================
        🟡 ACTION 3: REMIND ME LATER
        - DB me kuch change nahi
        - sirf modal band
  ================================================== */
  const handleRemindLater = () => {
    onClose();
  };

  /* ==================================================
        🧱 UI
  ================================================== */
  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-danger">
          {/* HEADER */}
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">🚨 Damage Reported!</h5>
          </div>

          {/* BODY */}
          <div className="modal-body text-center">
            {/* Proof Image */}
            <img
              src={request.proofImage || "https://via.placeholder.com/300"}
              alt="Damage Proof"
              className="img-fluid rounded mb-3 border"
              style={{ maxHeight: "200px" }}
            />

            <h4 className="text-danger fw-bold">
              Penalty: ₹{request.totalPenalty}
            </h4>

            <p className="text-muted">
              Owner says: "{request.lenderComment}"
            </p>

            {/* Dispute Reason Input */}
            {showDisputeInput && (
              <textarea
                className="form-control mb-2"
                placeholder="Why do you disagree? (e.g. It was already broken)"
                value={disputeReason}
                onChange={(e) => setDisputeReason(e.target.value)}
              />
            )}
          </div>

          {/* FOOTER */}
          <div className="modal-footer justify-content-center">
            {!showDisputeInput ? (
              <>
                <button
                  className="btn btn-success fw-bold px-4"
                  onClick={handlePay}
                  disabled={loading}
                >
                  ✅ Accept & Pay
                </button>

                <button
                  className="btn btn-danger fw-bold px-4"
                  onClick={handleDispute}
                  disabled={loading}
                >
                  ✋ Dispute
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={handleRemindLater}
                >
                  Remind Me Later
                </button>
              </>
            ) : (
              <>
                <button
                  className="btn btn-danger w-100"
                  onClick={handleDispute}
                  disabled={loading}
                >
                  Submit Dispute to Admin
                </button>
                <button
                  className="btn btn-link text-muted"
                  onClick={() => setShowDisputeInput(false)}
                >
                  Cancel
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PenaltyApprovalModal;
